// extracted by mini-css-extract-plugin
export var audioPlayer = "_o2-0";